import { forwardRef } from 'react';

const TextInput = forwardRef((props, ref) => {
  return <input ref={ref} type="text" className="form-control" spellCheck="true" {...props} />;
});

export default TextInput;
